$(window).scroll(function(){
    if ($(this).scrollTop() > 200) {
       $('.header-wrapper').addClass('scrolled_down');
    } else {
       $('.header-wrapper').removeClass('scrolled_down');
    }
});


document.addEventListener('DOMContentLoaded', function () {

  const allDetails = document.querySelectorAll('.menu-drawer__menu details');

  allDetails.forEach((detail) => {
    const summary = detail.querySelector('summary');
    const submenu = detail.querySelector('.menu-drawer__submenu');

    if (!summary || !submenu) return;

    /* ------------------------------
       STOP BUBBLING (CRITICAL FIX)
       Prevent child click from toggling parent
    ------------------------------- */
    summary.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    /* ------------------------------
       SMOOTH OPEN/CLOSE ANIMATION
    ------------------------------- */
    detail.addEventListener('toggle', function (e) {
      e.stopPropagation(); // prevents parent toggle

      if (detail.open) {
        submenu.style.maxHeight = submenu.scrollHeight + "px";
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + "px";
        setTimeout(() => {
          submenu.style.maxHeight = "0px";
        }, 10);
      }
    });

  });

});


document.addEventListener("DOMContentLoaded", function() {
    const textElement = document.getElementById("headerTextTyping");

    // Split phrases by || separator
    const texts = textElement.textContent.split('||').map(t => t.trim());

    let currentIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    const typingSpeed = 150;
    const deletingSpeed = 60;
    const pauseTime = 1800;

    function typeWriter() {
        const currentText = texts[currentIndex];

        if (isDeleting) {
            charIndex--;
            textElement.textContent = currentText.substring(0, charIndex);
        } else {
            charIndex++;
            textElement.textContent = currentText.substring(0, charIndex);
        }

        let timeout = isDeleting ? deletingSpeed : typingSpeed;

        // Pause after typing full phrase
        if (!isDeleting && charIndex === currentText.length) {
            timeout = pauseTime;
            isDeleting = true;
        } 
        // Move to next phrase after deleting
        else if (isDeleting && charIndex === 0) {
            isDeleting = false;
            currentIndex = (currentIndex + 1) % texts.length;
            timeout = typingSpeed;
        }

        setTimeout(typeWriter, timeout);
    }

    textElement.textContent = ""; // clear initial text
    typeWriter();
});

// Easysearh Custom Start
document.addEventListener('easysearch_loaded', function (){ 
  document.addEventListener('click', event => {
    const el = event.target.closest('[data-easysearch-action]');
    if( !el ) return;

    if( (el.dataset.easysearchAction === 'garage-add-to-garage' || el.dataset.easysearchAction === 'garage-add-item') && !el.hasAttribute('disabled') ) {
      const widget = document.querySelector('.easysearch-garage-widget');
      if( !widget ) return;

      easysearch._garageActionAddItem(widget);
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  });
});
// Easysearh Custom Finish

